import accountsClient from '@clients/accountsClient';
import CRMClient from '@clients/CRMClient';

const { getAccountDetails, accountSearchDocumentNumber } = accountsClient();
const { accountSearchCRM } = CRMClient();

type AccountSearchResultItem = {
    email: string;
    name: string;
    account_id: number;
    customer_id: number;
    program_type?: string;
};
type AccountSearchResult = AccountSearchResultItem[];

const searchQueries = {
    nameAndEmailCRM: (query: string) => accountSearchCRM({ query }),
    document: (query: string) =>
        accountSearchDocumentNumber({ documentNumber: query }),
    account: (query: string) =>
        getAccountDetails({ accountId: parseFloat(query) }),
};

const getAccountSearchQuery = (
    queryType: string,
    queryValue: string,
): Promise<AccountSearchResult> => {
    switch (queryType) {
        case 'account':
            return (
                searchQueries
                    .account(queryValue)
                    // We only get one item back from this api call so add it to an array to display in a list
                    .then((response) => [response])
            );
        case 'name':
        case 'email':
            return searchQueries.nameAndEmailCRM(queryValue);
        case 'document':
            return searchQueries.document(queryValue).then((response) => {
                // Look at list of responses and do a query for each to get more account information;
                const resultsWithAccountInfo = response.map((result) => {
                    return getAccountDetails({
                        accountId: result.account_id,
                    });
                });
                return Promise.all(resultsWithAccountInfo);
            });
    }
};

export default getAccountSearchQuery;
